/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ProjectEntry, ProjectEntry$inboundSchema } from "./projectentry.js";

export type ListProjectsResult = {
  /**
   * The list of projects
   */
  projects: Array<ProjectEntry>;
};

/** @internal */
export const ListProjectsResult$inboundSchema: z.ZodMiniType<
  ListProjectsResult,
  unknown
> = z.object({
  projects: z.array(ProjectEntry$inboundSchema),
});

export function listProjectsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListProjectsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListProjectsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListProjectsResult' from JSON`,
  );
}
